"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "setSessionState", {
  enumerable: true,
  get: function get() {
    return _setSessionState["default"];
  }
});
var _setSessionState = _interopRequireDefault(require("./setSessionState"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }